import {
  DataService,
  EntityManager,
  NamingConvention,
  EntityAction,
} from 'breeze-client';
import { AjaxFetchAdapter } from 'breeze-client/adapter-ajax-fetch';
import { DataServiceWebApiAdapter } from 'breeze-client/adapter-data-service-webapi';
import { ModelLibraryBackingStoreAdapter } from 'breeze-client/adapter-model-library-backing-store';
import { UriBuilderJsonAdapter } from 'breeze-client/adapter-uri-builder-json';
import { BASE_URL } from './base-url';
import { NorthwindMetadata } from './metadata';
import { NorthwindRegistrationHelper } from './registration-helper';

export class EntityManagerProvider {
  protected masterManager: EntityManager;

  constructor() {
    // configure breeze adapters
    ModelLibraryBackingStoreAdapter.register();
    UriBuilderJsonAdapter.register();
    AjaxFetchAdapter.register().defaultSettings = {
      headers: {
        'Access-Control-Allow-Origin': '*',
      },
    };
    AjaxFetchAdapter.register().requestInterceptor = ((req) => {
      req.config.headers = {
        'Access-Control-Allow-Origin': 'http://localhost:3000',
        Accept: 'application/json, text/plain',
        'Content-Type': 'application/json;charset=UTF-8',
      };
      req.config.Accept = 'application/json';
      req.config.withCredentials = false;
      req.config.credentials = 'same-origin';
      //req.config.headers.Authorization = 'Bearer oiwjeglkwjelkj';
    }) as any;
    DataServiceWebApiAdapter.register();
    NamingConvention.camelCase.setAsDefault();
    // adapterInstance.defaultSettings = {
    //   headers: {
    //     'Access-Control-Allow-Origin': '*',
    //   },
    // };
    // configure API endpoint
    const dataService = new DataService({
      // serviceName: 'https://localhost:5001/api/breeze',
      serviceName: `${BASE_URL}/api/breeze`,
      hasServerMetadata: false,
    });

    // register entity metadata
    this.masterManager = new EntityManager({ dataService });
    const metadataStore = this.masterManager.metadataStore;
    this.masterManager.validationOptions.validateOnSave = false;
    metadataStore.importMetadata(NorthwindMetadata.value);
    NorthwindRegistrationHelper.register(metadataStore);
  }

  /** Return empty manager configured with dataservice and metadata */
  newManager(): EntityManager {
    return this.masterManager.createEmptyCopy();
  }

  /** Call forceUpdate() on the component when an entity property or state changes */
  subscribeComponent(
    manager: EntityManager,
    component: { forceUpdate: () => void }
  ) {
    let subid = manager.entityChanged.subscribe(
      (data: { entityAction: EntityAction }) => {
        if (
          data.entityAction === EntityAction.PropertyChange ||
          data.entityAction === EntityAction.EntityStateChange
        ) {
          component.forceUpdate();
        }
      }
    );
    component['subid'] = subid;
  }

  /** Remove subscription created with subscribeComponent() */
  unsubscribeComponent(manager: EntityManager, component: any) {
    if (component.subid) {
      manager.entityChanged.unsubscribe(component.subid);
    }
  }
}

export const entityManagerProvider = new EntityManagerProvider();
